var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"M23 4H9a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V9a5 5 0 0 0-5-5zM12 23H9V12h3zm-1.5-12.27A1.77 1.77 0 1 1 12.25 9a1.75 1.75 0 0 1-1.75 1.73zM24 23h-3v-5.6c0-3.37-4-3.12-4 0V23h-3V12h3v1.77c1.4-2.59 7-2.78 7 2.47z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }